export class ProcessingError extends Error {
    constructor(msg?: string) {
        super(msg || 'There was an error processing your payment. \n Please try again later.');
    }
}
